import { call, put, takeLatest, all } from 'redux-saga/effects';
import { userService } from '../../services/userService';
import { UserActionTypes } from '../actions/userActions';
import { push } from 'connected-react-router';
import {
  DASHBOARD_PATH,
  LOGIN_PATH,
  CONFIRMATION_PATH
} from '../../utils/constants';

function* login(action) {
  try {
    const user = yield call(
      userService.login.bind(userService),
      action.payload.credentionals
    );
    yield put({ type: UserActionTypes.LOGIN_SUCCEEDED, user: user });
    yield put(push(DASHBOARD_PATH));
  } catch (e) {
    yield put({ type: UserActionTypes.LOGIN_FAILED, error: e });
  }
}

function* logout() {
  try {
    yield call(userService.logout.bind(userService));
    yield put({ type: UserActionTypes.LOGOUT_SUCCEEDED });
    yield put(push(LOGIN_PATH));
  } catch (e) {
    yield put({ type: UserActionTypes.LOGOUT_FAILED, error: e });
  }
}

function* resetPassword(action) {
  try {
    const { email, source_url } = action.payload;
    yield call(userService.resetPassword, email, source_url);
    yield put({ type: UserActionTypes.RESET_PASSWORD_SUCCEEDED, email });
  } catch (e) {
    yield put({ type: UserActionTypes.RESET_PASSWORD_FAILED, error: e });
  }
}

function* updatePassword(action) {
  try {
    const { token, password } = action.payload;
    yield call(userService.updatePassword, token, password);
    yield put({ type: UserActionTypes.UPDATE_PASSWORD_SUCCEEDED });
  } catch (e) {
    yield put({ type: UserActionTypes.UPDATE_PASSWORD_FAILED, error: e });
  }
}

function* resendActivation(action) {
  try {
    const { email, source_url } = action.payload;
    yield call(userService.resendActivation, email, source_url);
    yield put({ type: UserActionTypes.RESEND_ACTIVATION_SUCCEEDED, email });
  } catch (e) {
    yield put({ type: UserActionTypes.RESEND_ACTIVATION_FAILED, error: e });
  }
}

function* signup(action) {
  try {
    const { user } = action.payload;
    yield call(userService.register, user);
    yield put({ type: UserActionTypes.SIGNUP_SUCCEEDED, email: user.email });
    yield put(push(CONFIRMATION_PATH));
  } catch (e) {
    yield put({ type: UserActionTypes.SIGNUP_FAILED, error: e });
  }
}

function* userRootSaga() {
  yield all([
    yield takeLatest(UserActionTypes.LOGIN_REQUESTED, login),
    yield takeLatest(UserActionTypes.LOGOUT_REQUESTED, logout),
    yield takeLatest(UserActionTypes.RESET_PASSWORD_REQUESTED, resetPassword),
    yield takeLatest(UserActionTypes.UPDATE_PASSWORD_REQUESTED, updatePassword),
    yield takeLatest(
      UserActionTypes.RESEND_ACTIVATION_REQUESTED,
      resendActivation
    ),
    yield takeLatest(UserActionTypes.SIGNUP_REQUESTED, signup)
  ]);
}

export default userRootSaga;



// WEBPACK FOOTER //
// ./src/redux/sagas/UserSaga.js